<template>
  <div>
    <h3 style="margin-bottom:2em;">{{ text.main }} <span class="subheader">{{ text.sub }}</span></h3>
    <v-textarea v-if="addtype === 'additional'"
      v-model="additional"
      solo
      auto-grow
      name="additional"
      value=""
      color="rgb(135, 0, 0)"
    ></v-textarea>
    <v-textarea v-if="addtype === 'when'"
      v-model="when"
      solo
      auto-grow
      name="when"
      value=""
      color="rgb(135, 0, 0)"
    ></v-textarea>
    <v-textarea v-if="addtype === 'where'"
      v-model="where"
      solo
      auto-grow
      name="where"
      value=""
      color="rgb(135, 0, 0)"
    ></v-textarea>
  </div>
</template>

<script>
import { fromStore } from '../util'

export default {
  name: 'LayoutAdditional',
  props: {
    text: Object,
    addtype: String
  },
  computed: {
    additional: fromStore('additional'),
    when: fromStore('when'),
    where: fromStore('where')
  }
}
</script>

<style scoped>
.subheader {
  font-size: 12px;
  font-weight: 300;
}
</style>
